/** Customer fields required to generate deterministic mock section snapshots. */
export interface MockSectionCustomerInput {
  id: string;
  name: string;
  /** Two-letter US state for county map scope on Who We're Reaching. */
  usStateCode?: string | null;
}

// --- Seeded PRNG (mulberry32) --------------------------------------------
function hashString(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function mulberry32(seed: number): () => number {
  let a = seed || 1;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Deterministic seeded PRNG for mock section snapshots.
 * @param customerId - Report customer identifier.
 * @param period - Reporting period label.
 * @param sectionId - Library section identifier.
 * @returns Seeded random number generator in [0, 1).
 */
export function makeRng(
  customerId: string,
  period: string,
  sectionId: string,
): () => number {
  return mulberry32(hashString(`${customerId}|${period}|${sectionId}`));
}
